import { ObservedBoolMap } from "@/utils/ObservedBoolMap";

import type { NodeModel } from "@/models/nodes/types";

export class NodeHoverModel extends ObservedBoolMap<[node: NodeModel, index?: number]> {
  protected mapKey(node: NodeModel, index?: number): string {
    return `${node.id}${typeof index === "number" ? `-${index}` : ""}`;
  }
}
